import React from 'react'
import { Snackbar } from '@material-ui/core'
import MuiAlert from '@material-ui/lab/Alert';
import { useForm } from '../../context/formContext'

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const Toast = () => {
  const {
      toast,
      setToast
  } = useForm()

  const [open, setOpen] = React.useState(false);
  const [severity, setSeverity] = React.useState("transparent")

  React.useEffect(() => {
    setOpen(toast.show)
    setSeverity(toast.severity)
  }, [toast])

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setToast({show:false, message:undefined});
  }
  return (
    <>
        <Snackbar
            anchorOrigin={{vertical:'bottom', horizontal: 'right'}}
            style={{bottom: '10px', right: '10px', zIndex: '9999'}}
            open={open}
            onClose={handleClose}
            autoHideDuration={4000}
        >
          {open?<Alert onClose={handleClose} severity={severity}>
            {toast?.message || null}
          </Alert>:null}
        </Snackbar>
    </>
  )
}

export default Toast
